import React from "react";
import "./TableButton.css";

const TableButton = (props) => {
  return (
    <button
      className="table-button"
      style={{
        fontWeight: props.active ? "600" : "500",
        borderLeft: props.active ? "3px solid black" : "none",
        marginLeft: props.active ? "0px" : "3px",
      }}
      onClick={props.onClick}
    >
      <div className="icon">{props.icon}</div>
      {props.text}
    </button>
  );
};

export default TableButton;
